export default __webpack_public_path__ + "static/media/security.3cc21e69.png";